import { render, staticRenderFns } from "./ContactTitle2.vue?vue&type=template&id=4bd780ea&"
import script from "./ContactTitle2.vue?vue&type=script&lang=js&"
export * from "./ContactTitle2.vue?vue&type=script&lang=js&"
import style0 from "./ContactTitle2.vue?vue&type=style&index=0&id=4bd780ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports